import React from 'react';
import classNames from 'classnames';

interface IPercentageBarProps {
  color?: 'green' | 'orange' | 'dark-orange' | 'light-orange';
  percentage?: number;
  animate?: boolean;
}

export default function PercentageBar({
  color,
  percentage,
  animate,
}: IPercentageBarProps) {
  const classes = classNames(
    'percentage-bar',
    { 'percentage-bar--green': color === 'green' },
    { 'percentage-bar--orange': color === 'orange' },
    { 'percentage-bar--light-orange': color === 'light-orange' },
    { 'percentage-bar--dark-orange': color === 'dark-orange' },
    { 'percentage-bar--animated': animate },
  );

  return (
    <div className={classes}>
      <div
        className="percentage-bar__progress"
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
}
